import { useState, useEffect } from "react";
import { Progs } from "../ProgramState";
//router
import { useHistory } from "react-router-dom";
//styled
import styled from "styled-components";
//framer-motion
import { motion } from "framer-motion";
import { AnimPage } from "../Animation";

export default function ProgramDetails() {
	const history = useHistory();
	const url = history.location.pathname;
	const [progs, setProgs] = useState(Progs);
	const [prog, setProg] = useState(null);

	//useEffect
	useEffect(() => {
		const currentProg = progs.filter((stateProg) => stateProg.url === url);
		setProg(currentProg[0]);
	}, [progs, url]);
	console.log(setProgs);

	return (
		<>
			{prog && (
				<Details variants={AnimPage} exit="exit" initial="hidden" animate="show">
					<Headline>
						<h2>{prog.title}</h2>
						<img src={prog.Img} alt="workout" />
					</Headline>
					<Description>
						<p>{prog.description}</p>
					</Description>
					<SecImage>
						<img src={prog.SecImg} alt="workout" />
					</SecImage>
					<Description>
						<p >{prog.description}</p>
					</Description>
				</Details>
			)}
		</>
	);
}

const Details = styled(motion.div)`
	color: white;
`;
const Headline = styled.div`
   @media(max-width: 1300px){
	   min-height: 50vh;
	   padding-top: 10vh;
	   h2{
		   font-size: 3rem;
		   position: absolute;
	   }
	   img{
		   height: 50vh;
		   margin-top: 0rem;
	   }
   }
	min-height: 90vh;
	padding-top: 20vh;
	position: relative;
	h2 {
		text-transform: uppercase;
		position: absolute;
		top: 7%;
		left: 50%;
		transform: translate(-50%, -10%);
	}
	img {
		margin-top: 2rem;
		width: 100%;
		object-fit: cover;
	}
`;
const Description = styled.div`
	display: flex;
	flex-direction: column;
	margin: 5rem 10rem;
	@media(max-width: 1300px){
		margin: 5rem 2rem;
	}
`;
const SecImage = styled.div`
@media(max-width: 1300px){
	img{
		height: 50vh;
	}
}
	min-height: 50vh;
	img {
		width: 100%;
		object-fit: cover;
	}
`;
